<template>
  <v-snackbar
    v-model="toast.state.value.show"
    :timeout="toast.state.value.timeout"
    :color="toast.state.value.type"
    location="bottom right"
    variant="elevated"
  >
    <div class="d-flex align-center ga-2">
      <v-icon :icon="icon" />
      <span>{{ toast.state.value.message }}</span>
    </div>

    <template #actions>
      <v-btn
        variant="text"
        icon="mdi-close"
        size="small"
        @click="toast.hide()"
        aria-label="Fermer la notification"
      />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
const toast = useToast()

const icon = computed(() => {
  switch (toast.state.value.type) {
    case 'success':
      return 'mdi-check-circle'
    case 'error':
      return 'mdi-alert-circle'
    case 'warning':
      return 'mdi-alert'
    case 'info':
      return 'mdi-information'
    default:
      return 'mdi-information'
  }
})
</script>
